import { Box, Slider, Typography } from '@mui/material';
import { FormControlProps, FormElementControlPropsType } from './index';
import styles from 'components/common/form/layout/control/FormSlider.styles';
import { FormComponentBuilder } from 'components/common/form/layout';

export interface FormControlSliderProps extends FormControlProps {
    max?: number;
    min?: number;
    step?: number;
    disabled?: boolean;
    defaultValue?: string;
}

export default function FormSlider({ controlProps }: FormElementControlPropsType<FormControlSliderProps>) {
    const value = typeof controlProps.value === 'undefined' ? controlProps.defaultValue : controlProps.value;
    const valueToShow =
        typeof controlProps.value !== 'undefined' ? controlProps.value : controlProps.defaultValue || controlProps.min;

    const handleChange = (event: any, value: number | number[]) => {
        const sValue = Array.isArray(value) ? value : String(value);
        if (typeof event?.target?.value != 'undefined') {
            event.target.value = String(value);
        }
        controlProps.onChange(event, sValue);
    };

    return (
        <Box sx={styles.box}>
            <Slider
                min={controlProps.min}
                max={controlProps.max}
                step={controlProps.step}
                disabled={controlProps.disabled}
                onChange={handleChange}
                value={Number(value)}
                defaultValue={Number(controlProps.defaultValue)}
            />
            <Typography sx={styles.value}>{valueToShow}</Typography>
        </Box>
    );
}

export class FormSliderBuilder extends FormComponentBuilder {
    prepareProps(): FormControlSliderProps {
        return {
            ...this.controlProps,
            min: this.elementProps.componentProps?.min,
            max: this.elementProps.componentProps?.max,
            step: this.elementProps.componentProps?.step,
            disabled: this.elementProps.componentProps?.disabled ?? false,
            defaultValue: this.elementProps.componentProps?.defaultValue ?? '0',
        };
    }
}
